import { configureApi } from 'react-reqq-lite';
import Cookie from 'js-cookie';
import { get } from 'lodash';
import { toastError } from 'react-geek-toast';
import history from './history';

const store = configureApi({
  endpoint: process.env.REACT_APP_END_POINT,
  requestHeaders: () => {
    const token = Cookie.get('_token');
    if (!token)
      return {
        'Content-Type': 'application/json',
      };
    return {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
  },
  timeout: 180000,
  onError: (err) => {
    const err_message = get(err, 'response.message');
    if (err.status === 401) {
      const message = get(
        err,
        `response.errors.${Object.keys(get(err, 'response.errors') || [])[0]}`
      );
      toastError(message || 'Unauthorized!');
      return;
    }
    if (err.status === 422) {
      const message_res = get(
        err,
        `response.errors.${Object.keys(get(err, 'response.errors') || [])[0]}.0`
      );
      const message = get(
        err,
        `response.${Object.keys(get(err, 'response') || [])[0]}.0`
      );
      toastError(message_res || message || 'Unprocessable Entity!');
      return;
    }
    if (err.status === 400) {
      toastError(err_message || 'Bad Request!');
      return;
    }
    if (err.status === 404) {
      if (err_message === "User is already verified.") {
        toastError(err_message || 'Bad Request!');
      }
      return;
    }
    // if (err.status === 500) {
    //   toastError(err_message || 'Internal Server Error!');
    //   return;
    // }
    if (err.status === 403) {
      if (
        err_message === 'Invalid token.' ||
        err_message === 'Token expired.' ||
        err_message === 'Token Expired'
      )
        toastError(err_message || 'Forbidden!');
      history.push('/logout');
      return;
    }
    if (err.status === 500) {
      toastError('Something went wrong!');
    }
    if (err.status === 0) {
      toastError('Unable to connect to web service');
      return;
    }
    console.warn('unhandled error', err); // eslint-disable-line
  },
});

export default store;
